import { useQuery } from "react-query";
import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";

export function useClaimUserRoles(username?: string | undefined) {
  const apiHandler = useContext(ApiContext);
  return useQuery({
    queryKey: ["userRoles", username],
    queryFn: async () => await apiHandler.utp2AccountApis.getClaimRoles(username),
    enabled: !!username,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
  });
}
